import React from "react";
import GooglePlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-google-places-autocomplete";
import { GoogleAPI } from "../../utils/keys";

interface LocationInputProps {
  value?: any;
  setValue?: (value: any) => void;
  setCenter?: (value: { latitude: number; longitude: number }) => void;
  onSelectLocation?: (location: { address: string; latitude: number; longitude: number }) => void;
  placeholder?: string;
  height?: number;
}

const LocationInput = ({
  value,
  setValue,
  setCenter,
  onSelectLocation,
  placeholder,
  height,
}: LocationInputProps) => {
  const handleChange = (suggestion: any) => {
    setValue && setValue(suggestion);

    geocodeByAddress(suggestion.label)
      .then((results) => getLatLng(results[0]))
      .then(({ lat, lng }) => {
       
        setCenter &&
          setCenter({
            latitude: lat,
            longitude: lng,
          });
        onSelectLocation &&
          onSelectLocation({
            address: suggestion.label,
            latitude: lat,
            longitude: lng,
          });
      });
  };

  return (
    <div>
      <GooglePlacesAutocomplete
        apiKey={GoogleAPI}
        selectProps={{
          value,
          onChange: handleChange,
          placeholder,
          styles: {
            input: (provided) => ({
              ...provided,
              height: height || 40,
            }),
          },
        }}
      />
    </div>
  );
};

export default LocationInput;
